import { css } from '@emotion/react'
import isUndefined from 'lodash/isUndefined'
import { FC } from 'react'

type Props = {
  text?: string
}

const HelperText: FC<Props> = ({ text }) => {
  if (isUndefined(text)) return null

  return <p css={helperTextStyle()}>{text}</p>
}

export default HelperText

const helperTextStyle = () => css`
  color: rgba(255, 255, 255, 0.6);
  font-size: 12px;
  line-height: calc(18 / 12);

  @media (max-width: 767px) {
    line-height: calc(17 / 12);
  }
`
